export const MODAL_SHOW = "modal/show";
export const MODAL_CLOSE = "modal/close";
export const CLOSE_ALL_MODALS = "modal/closeAll";

export const OPEN_START_DETAILS = "modal/openStartDetails";
export const CLOSE_START_DETAILS = "modal/closeStartDetails";

export const FINISH_PURCHASE_FLOW = "modal/finishPurchaseFlow";
export const RESTORE_PURCHASE_FLOW = "modal/restorePurchaseFlow";

export type ActionType =
    | typeof MODAL_SHOW
    | typeof MODAL_CLOSE
    | typeof CLOSE_ALL_MODALS
    | typeof OPEN_START_DETAILS
    | typeof CLOSE_START_DETAILS
    | typeof FINISH_PURCHASE_FLOW
    | typeof RESTORE_PURCHASE_FLOW;

type Action = {
    type: ActionType;
    payload: string | {modalId: string};
};

export type ShowAction = {
    type: typeof MODAL_SHOW;
    payload: string | {modalId: string};
};

export type CloseAction = {
    type: typeof MODAL_CLOSE;
    payload: string | {modalId: string};
};

export type ModalAction = Action | ShowAction | CloseAction;
